import * as React from 'react';
import { getContentFronStorage } from '../utils/index';
import { RouterData } from '../shared/index';
import { CMS } from '../shared/index';
import { GetImageUrl, newI18n } from '../core/index';
import { Link } from 'react-router-dom';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
export interface Homesection2Props extends BaseComponentProps {
	lang: string;
	currency: string;
	history: RouterData.History;
}
export interface Homesection2State extends BaseComponentState {
	data: CMS.CmsDestinationsZones[];
	// titleAndDescription: CMS.CmsPavoriteDestinationsZones;
}

export class Homesection2 extends BaseComponent<Homesection2Props, Homesection2State> {

	imageUrl = GetImageUrl();
	 
	translation = {
		Title: newI18n("HOME.HOTELLOCATION.Title", "Choose from Bali's Top Locations "),
		SubTitle: newI18n("HOME.HOTELLOCATION.SubTitle", " "),
		ViewHotelList: newI18n("HOME.HOTELLOCATION.ViewHotelList", "View Hotel List"),
	};

	constructor(props: Homesection2Props) {
		super(props);
		this.state = {
			data: [],
			// titleAndDescription: {}
		};

	}

	componentDidMount() {
		this.getLoc();
	}
	componentDidUpdate(prevProps: Homesection2Props, prevState: Homesection2State) {
		if (prevProps.lang !== this.props.lang) {
			this.getLoc();
		}
	}

	getLoc: () => any = () => { 
		getContentFronStorage(this.props.lang, "CmsDestinationsZones").then(
			(d: any[]) => {
				this.setState({ data: d });
			}).catch((exc) => { console.error('error: ', exc); });

	}
	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		let slide: any[] = [];
		let imgstyle = {
			marginRight: 20,
			width: 180,
			float: 'left'
		};
		if (typeof this.state.data === 'undefined') {
			slide.push(<span key='spacer_undefined_data' />);
		} else {
			let lop = 0;
			if (this.state.data.length > 0) {
				for (let apokadenne of this.state.data) {
					lop++;
					let img = <span />;
					if (apokadenne.thumbUrl!.substring(0, 4) === 'http') {
						img = <img alt="" style={imgstyle as any} src={`${apokadenne.thumbUrl}`} className="img-responsive" />;
					} else {
						img = <img alt="" style={imgstyle as any} src={`${this.imageUrl}/destinations/` + apokadenne.thumbUrl} className="img-responsive" />;
					}
					slide.push(

						<div key={`keys-${lop}`} className="col-md-6 col-sm-6" style={{ marginBottom: 15 }}>
							<div className=" ">
								<Link to={apokadenne.slug} className="links cl-effect-1">{img}</Link>
								<div >
									<h4>{apokadenne.homeTitle}</h4>
									<p className="description">
										{apokadenne.homeContent}
									</p>
									<Link to={apokadenne.slug} className="links cl-effect-1">{this.translation.ViewHotelList}</Link>
								</div>
							</div>
						</div>

					);
				}
			}

		}

		let renderDesctiption = (x: any) => {
			return { __html: x };
		};

		return (
			<section className="container-fluid container-fullw" style={{ paddingBottom: 30 }}>
				<div className="row">
					<div className="col-md-12">
						<h2 className="center " data-appears-class="fadeInUp" data-appears-delay="300">{this.translation.Title}</h2>
						<hr /> 
						<p className="text-center " data-appears-class="fadeInDown" data-appears-delay="300" dangerouslySetInnerHTML={renderDesctiption(this.translation.SubTitle)} />
						<div className=" container" style={{ marginTop: 30 }}>

							{slide}

						</div>
					</div>
				</div>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/home/Homesection2.tsx